import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { get, merge, cloneDeep } from 'lodash';
import { withRouter } from 'react-router';

import * as jobRequestApi from '../../../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../../../redux/actionCreators/sync/jobrequests';
import {getSchema as getJobSchema} from '../../../../models/jobRequest';

import TextArea from '../../../../common/components/c_TextArea';
import SubmissionBar from '../../SubmissionBar';

import RouteTransitionBlocker from '../../../r_ApplicantDashboard/f_RouteTransitionBlocker';

@connect((store, props) => {
	return {
		staticData: store.staticData,
		user: store.user,
		jobRequest: store.jobRequest,
		jobId: parseInt(props.params.jobId || 0, 10),
	};
})
class JobRequestDescription extends Component {

	static propTypes = {
		staticData: PropTypes.object.isRequired,
		user: PropTypes.object,
		checkComplete: PropTypes.func
	}

	constructor(props, context) {
		super(props, context);

		this.state = {
			clientId: this.props.user.profileId,
			submitted: false, // save and next.
			jobRequest: null,
			jobRequestModel: {
				id: this.props.jobId,
				primaryContactId: this.props.user.profileId,
				description: get(props.jobRequest, 'description') || '',
			},
			showTransitionBlocker: false,
			transitionRoute: '',
			stateSaved: true,
		};

    this.isJobDescriptionFilled = ::this.isJobDescriptionFilled;
    this.getJobDescriptionValue = ::this.getJobDescriptionValue;

	}

	componentDidMount() {

		this.props.router.setRouteLeaveHook(this.props.route, (location) => {

			const jobRequestSteps = /\/client\/jobrequest\/(.*)\/?(.*)/;

			if (jobRequestSteps.test(location.pathname)) {
				this.state.primaryButtonLabel = 'Stay';
				this.state.secondaryButtonLabel = 'Leave';

			}else{
				this.state.primaryButtonLabel = undefined;
				this.state.secondaryButtonLabel = undefined;
			}

			if (!this.state.stateSaved) {
				this.setState(merge({}, this.state, {showTransitionBlocker: true,  transitionRoute: location.pathname}));
				return this.state.stateSaved;
			} else {
				return true;
			}

		});
	}

  componentWillReceiveProps(nextProps) {
    if (nextProps.jobRequest) {
      this.state.jobRequestModel.description = get(nextProps.jobRequest, 'description');
      this.setState(merge({}, this.state));
    }
  }

  getJobDescriptionValue() {
    return get(this.state.jobRequestModel, 'description') || '';
  }

  getCount(str) {
    return str.split(' ').filter(function(num) {
      return num !== '';
    }).length;
  }

  isJobDescriptionFilled() {
    return this.getCount(this.getJobDescriptionValue()) >= 100;
  }

	save = (clientId, jobRequestModel) => {

		const updateJobRequest = this.props.dispatch(jobRequestApi.updateJobRequest(clientId, jobRequestModel));
		return updateJobRequest.then(() => {

			// update store.

			const updatedJobRequestStore = cloneDeep(this.props.jobRequest);
			updatedJobRequestStore.description = this.getJobDescriptionValue();
			this.props.dispatch(jobRequestStore.updateJobRequest({...this.state.jobRequestModel}));

		});

	}

	handleSave = (event, cb) => {

    this.setState({submitted: true}, () => {
      if(!this.isJobDescriptionFilled()) return;

      this.save(this.state.clientId, this.state.jobRequestModel)
      .then(() => this.setState({stateSaved: true}, cb));
    });

	}

	handleSaveAndNext = (event) => {

		this.setState({submitted: true}, () => {
      this.handleSave(event, () => {
        this.props.checkComplete();
        this.gotoNextScreen();
      });
    });
	}

	gotoNextScreen = () => {
		this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/adddocuments`));
	}

	handleBack = (event) => {
		this.setState({submitted: true}, () => {
      if (!this.isJobDescriptionFilled()) return;
      this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}`));
    });
	}

	handleChange(prop) {
		return (event, value, primaryText) => {
			const jobRequest = this.state.jobRequestModel;
			jobRequest[prop] = value;
			this.setState({stateSaved:false});
		};
	}

	closeTransitionBlocker = () => {
		this.setState(merge({}, this.state, {showTransitionBlocker: false}));
	}

	transitionFunction = () => {
		this.setState({stateSaved: true}, () =>  this.props.dispatch(push(this.state.transitionRoute)));
	}


  render() {
		const jobSummaryDescription = 'Description';
		const errorText = this.state.submitted && !this.isJobDescriptionFilled() && 'This field is required and must be 100 words minimum.';

		return (
			<div className='job-request-description'>
		{
				this.state.showTransitionBlocker
				&&
				<RouteTransitionBlocker
					cancelAction={this.closeTransitionBlocker.bind(this)}
					primaryAction={this.closeTransitionBlocker.bind(this)}
					primaryButtonLabel={this.state.primaryButtonLabel}
					secondaryAction={this.transitionFunction.bind(this)}
          secondaryButtonLabel={this.state.secondaryButtonLabel}
					transitionText={'You are leaving the Job Request record. Please click on Save first before you exit.'}
				/>
		}
						<h1> Job Description </h1>
					<h2>Please provide us with a job description for the position. You can copy and paste an existing Job Description into this field. You can also add additional supporting documents. </h2>
          <div>Please include at a minimum, one paragraph position description, and five (5) daily job functions.  There is a minimum 100 word count requirement.</div>
          <br></br>
          <br></br>
					<TextArea
						style={{minHeight: '295px'}}
						description={jobSummaryDescription}
						value={get(this.state.jobRequestModel, 'description')}
						onChange={this.handleChange('description')}
						isDirty={true}
						errorText={errorText}
					/>

          <span>(100 words minimum, current word count is {this.getCount(get(this.state.jobRequestModel, 'description'))})</span>
					<SubmissionBar
						onBack={this.handleBack}
						onNext={this.handleSaveAndNext}
						onSave={this.handleSave}
					/>
			</div>
		);
	}
}
export default withRouter(JobRequestDescription);



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/JobRequestDescription/index.js